
import { useAppStore } from "/@/store/modules/app";
import { updateDarkTheme } from "./dark";
import { initAuth, initOnline } from "/@/core/auth";


export  async function initAppConfigStore  () {
  const appStore = useAppStore();
  const darkMode = appStore.getDarkMode;
  // 暗黑模式
  updateDarkTheme(darkMode);
  // 获取权限
  await initAuth()
  await initOnline()
}